import { SiteFooter, SiteHeader } from "../components/site-header";

export function TermsRoute() {
  return (
    <div className="site-shell">
      <SiteHeader />
      <main className="document-page">
        <header className="document-page__header">
          <p className="eyebrow">BEFORE YOU START</p>
          <h1>利用上の注意</h1>
          <p>診断を楽しむために、以下を確認してください。</p>
        </header>
        <section aria-labelledby="scope-heading">
          <h2 id="scope-heading">娯楽的セルフチェックです</h2>
          <p>
            この診断は、心理学の関連概念を参考にした娯楽的セルフチェックです。医療的・臨床的な診断ではなく、性格や原因を断定するものではありません。
          </p>
          <p>
            結果は医療的・臨床的な診断ではありません。採用、人事評価、治療方針、その他の重要な判断には使用しないでください。
          </p>
        </section>
        <section aria-labelledby="age-heading">
          <h2 id="age-heading">対象年齢</h2>
          <p>対象年齢は18歳以上です。年齢や生年月日の入力は求めません。</p>
        </section>
        <section aria-labelledby="interpretation-heading">
          <h2 id="interpretation-heading">結果の受け取り方</h2>
          <p>
            結果は回答時点の自己申告をもとにした行動傾向です。病名、人格障害、善悪を示すものではありません。毒コメントは行動への風刺としてお読みください。
          </p>
          <p>
            結果を共有するときは、自分や第三者の氏名・連絡先などを投稿文へ含めないでください。
          </p>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
